import React from "react";
import { Container, Row } from "react-bootstrap";
import parse from "html-react-parser";
import BreadCrumbs from "../PropertyDetails/BackButton/BreadCrumbs";
import NewsCategories from "./NewsCategories/NewsCategories";
import './NewsLanding.scss';

const NewsHeader = (props) => {
    return(
        <React.Fragment>
            <section className="landing-banner introbanner scroll-intro news-page-header">
                <Container>
                    <Row>                        
                        <div className="banner-content">
                                <BreadCrumbs style="banner-breadcrumbs" alias="latest-property-news" baseurl={"/about/latest-property-news/"} menulabel={props?.categoryName}/>
                                <div className="banner-intro-content">
                                    <span className="sm-text">{props?.title}</span>
                                    {props?.content ? parse(props?.content) : ''}
                                </div>
                                <NewsCategories categorySlug={props?.categorySlug} />
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default NewsHeader;